import { render, staticRenderFns } from "./shareHistory.vue?vue&type=template&id=1fba45b7&scoped=true"
import script from "./shareHistory.vue?vue&type=script&lang=js"
export * from "./shareHistory.vue?vue&type=script&lang=js"
import style0 from "./shareHistory.vue?vue&type=style&index=0&id=1fba45b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba45b7",
  null
  
)

export default component.exports